import React from 'react'
import PropTypes from 'prop-types'

import Loading from '@piconetworks/loading'

import logger from 'common/logger'

class LogoutPage extends React.Component {
    componentDidMount() {
        const {
            publisherId,
            accessToken,
            refreshToken,
            logout,
            onLoggedOut,
        } = this.props

        logger.info('Logout called from logout component', { props: this.props })
        logout({
            publisherId,
        })

        if (!accessToken && !refreshToken) {
            onLoggedOut()
        }
    }

    componentDidUpdate() {
        const {
            accessToken,
            refreshToken,
            onLoggedOut,
        } = this.props

        if (!accessToken && !refreshToken) {
            onLoggedOut()
        }
    }

    render() {
        const { disableLoading } = this.props

        if (disableLoading) {
            return null
        }

        return (
            <Loading inlineStyle={{ top: '110px' }} />
        )
    }
}

LogoutPage.defaultProps = {
    publisherId: null,
    accessToken: null,
    refreshToken: null,
    logout: () => {},
    onLoggedOut: () => {},
    disableLoading: false,
}

LogoutPage.propTypes = {
    logout: PropTypes.func,
    onLoggedOut: PropTypes.func,
    publisherId: PropTypes.string,
    accessToken: PropTypes.string,
    refreshToken: PropTypes.string,
    disableLoading: PropTypes.bool,
}

export default LogoutPage
